import { Component, Injector, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { userRoles } from '../../../../../../data/admin-master-data';
import { AdminUsersService } from '../../../../../../services/admin-users.service.';
import { GlobalValidators } from '../../../../../../utils/utils';
import { DialogAbstractComponent } from '../../../../../../shared/dialogs/dialog.class';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.scss'],
})
export class UserModalComponent extends DialogAbstractComponent implements OnInit {
  isAdd = 'edit';
  addUserFormGroup: FormGroup;
  changePWType = false;
  addAdminUserInProgress;
  addAdminUserSuccessStatus;
  uploadError;
  avatarUrl = new FormControl();
  userData: any;
  URLAddress: String;
  userRoleSelected = false;
  roles = this.dialogParams.roles;
  isAdmin = this.dialogParams.isAdmin;
  emailAvailable;
  userRoles = userRoles;
  constructor(injector: Injector, private adminUserService: AdminUsersService, private fb: FormBuilder) {
    super(injector);
  }

  ngOnInit() {
    this.isAdd = this.dialogParams.userObj === '' ? 'Add' : 'Save';
    this.bindForm(this.dialogParams.userObj);
  }

  checkArray(data) {
    if (data !== '') {
      for (let i = 0; i < this.dialogParams.roles.length; i++) {
        this.dialogParams.roles[i].selected = undefined;
        for (let j = 0; j < data.length; j++) {
          if (this.dialogParams.roles[i].role === data[j]) {
            this.dialogParams.roles[i].selected = true;
          }
        }
      }
    }
    return this.dialogParams.roles.map((c) => new FormControl(c.selected));
  }

  bindForm(data?) {
    console.log(data.roles);
    this.addUserFormGroup = this.fb.group({
      firstName: [data.firstName || '', [GlobalValidators.required]],
      lastName: [data.lastName || '', [GlobalValidators.required]],
      email: [{ value: data.email || '', disabled: data.email }, [GlobalValidators.required, GlobalValidators.email]], // password: [data.password || '', [Validators.required, GlobalValidators.password()]],
      designation: [data.designation || '', [GlobalValidators.required]],
      roles: new FormArray(this.checkArray(data.roles || ''), this.validateRoles.bind(this)),
      avatarUrl: [data.avatarUrl || ''],
    }); // set user privileges // this.avatarUrl.setValue(data.avatarUrl || 'assets/images/default-profile-pic-plus.png')

    this.addUserFormGroup.get('avatarUrl').valueChanges.subscribe((value) => {
      if (!!value) {
        let previewImageUrl = this.addUserFormGroup.get('avatarUrl');

        // this.addUserFormGroup.get('avatarUrl').setValue(previewImageUrl);
        this.URLAddress = previewImageUrl.value;
      }
    });

    if (data.roles.length > 0) {
      data.roles.forEach((role) => {
        if (role.indexOf('_RM_') >= 0) {
          if (role.indexOf('ROLE_RM_CORP_FIN') >= 0) {
            this.onChange('RM Corporate Finance', 12);
          } else {
            this.onChange(this.userRoles[role][0].description, 12);
          }
        }
      });
    }
    this.addUserFormGroup.get('email').valueChanges.subscribe((value) => {
      if (!!value) {
        this.emailAvailability(value);
      }
    });
  }
  onChange(data, i) {
    const n = (this.addUserFormGroup.get('roles') as FormArray).controls;
    const lastItem = (this.addUserFormGroup.get('roles') as FormArray).controls.length - 1;
    let rmList = [];
    for (let _i = lastItem - 4; _i <= lastItem - 1; _i++) {
      rmList.push(_i);
    }
    if (data.indexOf('RM') >= 0) {
      if (data.indexOf('Corporate Finance') >= 0) {
        for (let _i = i - 4; _i <= i - 1; _i++) {
          if (n[i].value) {
            (this.addUserFormGroup.get('roles') as FormArray).controls[_i].disable();
          } else {
            (this.addUserFormGroup.get('roles') as FormArray).controls[_i].enable();
          }
        }
      } else {
        let isEnableRm = rmList.some((item) => {
          return n[item].value === true;
        });
        if (isEnableRm) {
          (this.addUserFormGroup.get('roles') as FormArray).controls[lastItem].setValue(false);
          (this.addUserFormGroup.get('roles') as FormArray).controls[lastItem].disable();
        } else {
          (this.addUserFormGroup.get('roles') as FormArray).controls[lastItem].enable();
        }
      }
    }
  }
  async emailAvailability(value) {
    let available;
    try {
      await this.adminUserService.checkEmailAvailability(value);
      available = false;
    } catch (e) {
      available = true;
    }
    if (available) {
      this.addUserFormGroup.get('email').setErrors({ emailAvailable: true });
    } else {
      this.addUserFormGroup.get('email').markAsTouched();
    }
  }
  validateRoles(arr: FormArray) {
    const obj = <any>Object;
    const roles = obj.values(arr.value);
    if (!roles.some((role) => role)) {
      return { required: true };
    }
    return null;
  }
  reset(form) {
    form.resetForm();
  }

  setUploadError(error) {
    this.uploadError = error;
    setTimeout(() => {
      this.uploadError = undefined;
    }, 2400);
  }

  displayPassword() {
    this.changePWType = !this.changePWType;
  }

  async handleAdminUser(form) {
    if (form.invalid) {
      return;
    }
    try {
      this.addAdminUserInProgress = true;
      let roleNames = [];
      let k = roleNames.length;
      for (let i = 0; i < this.addUserFormGroup.getRawValue().roles.length; i++) {
        if (this.addUserFormGroup.getRawValue().roles[i]) {
          roleNames[k] = this.dialogParams.roles[i].role;
          k++;
        }
      }
      if (this.dialogParams.userObj === '') {
        try {
          form.value.roles = roleNames;
          await this.adminUserService.addUser(form.value);
        } catch (e) {}
      } else {
        form.value.roles = roleNames;
        await this.adminUserService.updateUser(form.value, this.dialogParams.userObj.id);
      }
      this.addAdminUserInProgress = false;
      this.addAdminUserSuccessStatus = 'success';
      setTimeout(() => {
        this.closeDialog(false);
      }, 1500);
    } catch (e) {}
  }
}
